import React, { useEffect } from "react";

const Modal = ({ isOpen, onClose, title, children, type, features = {}, onFeatureClick,setFeatures }) => {
    // Close modal when pressing Escape key
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onClose]);
    if (!isOpen) return null;

return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white p-6 rounded-lg shadow-lg w-100%">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <div className="w-full text-center">
            {title && <h2 className="text-2xl font-semibold mt-13">{title}</h2>}
          </div>
          <button onClick={onClose} className="text-gray-800 hover:bg-orange-300 bg-[#c97c5d] mt-13 text-3xl p-1 h-10 w-10 font-bold cursor-pointer">&times;</button>
        </div>

        {/* Modal Content */}
        <div>{children}</div>

        {type === 'preview' && (
          <div className="mb-12 flex justify-center gap-4 flex-wrap">
            {[
              { key: 'FeatureProduct', label: 'Featured Product' },
              { key: 'NewProduct', label: 'New Product' },
              { key: 'Status', label: 'Status' },
            ].map((item) => (
              <button
                key={item.key}
                onClick={() => onFeatureClick(item.key)} 
                className={`px-4 py-2 text-sm rounded-full shadow font-semibold min-w-[150px] transition-all
                  ${
                    item.key === 'Status'
                      ? features.Status === 'Approved'
                        ? 'bg-green-600 text-white hover:bg-green-700'
                        : features.Status === 'Rejected'
                        ? 'bg-red-500 text-white hover:bg-red-600'
                        : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                      : features[item.key]
                      ? 'bg-green-600 text-white hover:bg-green-700'
                      : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                  }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;